<template>
  <div class="w-100">
    <m-card450 :alt="product.name" :image="product.thumbnail" :link-target="productCardLink"
               :image-link="{ name: 'Product', params: { name: product.raw_link } }">


      <template #p-1>
        <h6 class="product-card-450-text">
          {{ product.user.name }} {{ product.user.last_name }}
        </h6>
      </template>

      <template #p-2>
        <div class="card450-product-date">{{ dateConverter(product.created_at) }}</div>
      </template>


      <template #p-3>
        <div class="d-inline-block mr-1">

          {{ findFeatureWithSelectedName(product, 'origin') }}

        </div>
      </template>

      <template #p-4>
        <div class="d-inline-block mr-1">

          {{ findFeatureWithSelectedName(product, 'destination') }}

        </div>
      </template>

      <template #p-5>
        <div class="">

          {{ findFeatureWithSelectedName(product, 'car_type') }}

        </div>
      </template>

      <template #p-6>
        <div class="">
          {{ findFeatureWithSelectedName(product, 'burden_type') }} تومان
        </div>
      </template>
      <template #p-7>
        <div class="text-center my-1">
          <template v-if="accessToAdminFeatures">

            <div class="col-lg-12">
              <div class="row justify-content-around align-items-center align-baseline">
                <m-a class="btn btn-primary rounded-pill my-1  product-card-450-edit-button"
                     :href="{ name: 'EditProduct', params: { slug: product.raw_link } }"
                     v-t="`product.card.edit`">
                </m-a>

                <m-delete-1 class="product-card-450-trash" iconName="trash" :itemId="product.id"/>

              </div>
            </div>

          </template>

          <template v-else>
            <div class="col-12">
              <div class="row justify-content-around align-items-center align-baseline">
                <m-product-card-quantity-manager1 :in-active-quantity-manager="inActiveQuantityManager"
                                                  :setUnauthenticatedShoppingCartFromLoginUser="true"
                                                  :redirect-after-add-digital-product="true"
                                                  :show-modal-if-product-category-inside-cash-on-delivery="true"
                                                  class="product-card-450-quantity-manager my-1"
                                                  :product="product"/>
                <m-a :href="{ name: 'Product', params: { name: product.raw_link } }">
                  <button type="button" class="btn btn-primary rounded-pill" v-t="`product.card.more`"/>
                </m-a>

                <m-a :href="`tel:${product.user.cellphone}`">
                  <m-icon class="h5" icon="telephone-fill"/>
                </m-a>
              </div>
            </div>


          </template>

        </div>
      </template>

      <template #p-bottom>
        <div class="col-12 rounded product-card-450-publish-status-danger"
             v-if="accessToAdminFeatures && !publishStatus">
          {{ publishStatusText }}
        </div>
        <div class="col-12 rounded product-card-450-publish-status-success"
             v-if="accessToAdminFeatures && publishStatus">
          {{ publishStatusText }}
        </div>

      </template>

    </m-card450>
  </div>

</template>

<script>
import {mapGetters} from "vuex";
import mCard450 from "../../Cards/Card450";
import mProductCardQuantityManager1 from "../../Product/QuantityManager/Card/ProductCardQuantityManager1";
import mProductPrice100 from "../../Product/ProductPrice100";
import mA from '../../Tags/A'
import mIcon from '../../Icons/Icon.vue'
import mProductOffer1 from "../../Product/ProductOffer/ProductOffer1";
import {OfferProps} from '../ProductOffer/ProductOfferProps'
import {shoppingCartFunctions} from "@moeinmdn/mixitweb-front-modules/src/plugin/class/ShoppingCartFunctions";
import {dateConverter} from "@moeinmdn/mixitweb-front-modules/src/plugin/class/Converter";
import {
  addFeatureToProduct,
  featureCategories, findFeatureWithSelectedName, groupByType, productFeatureValue,
  removeChildFeature, removeEmptyGroups, sortedFeaturesMethod
} from "@moeinmdn/mixitweb-front-modules/src/plugin/Modules/Product";
import mDelete1 from "../../Tool/Delete/Delete1.vue";

export default {
  name: "ProductCard450",
  components: { mCard450, mDelete1, mProductCardQuantityManager1, mA, mProductPrice100, mProductOffer1, mIcon},
  props: {
    product: {},
    productCardLink: {
      default: '_self',
    },
    inActiveQuantityManager: {
      type: Boolean,
      default: true
    },
    showKeywords: {
      type: Boolean,
      default: false
    },
    OfferProps
  },
  computed: {
    ...mapGetters({
      profile: "User/getProfile"
    }),
    productFeatures() {
      return this.product.feature_product
    },
    publishStatus() {
      return this.product.status == 0 ? false : true
    },
    publishStatusText() {
      if (this.publishStatus) { // published true
        return this.$t('filter.product_status.publish')
      }
      return this.$t('filter.product_status.draft')
    },
    accessToAdminFeatures() {
      return [1, 2].indexOf(this.profile.role) > -1
    }
  },
  methods: {
    dateConverter,
    addFeatureToProduct,
    featureCategories,
    groupByType,
    removeChildFeature,
    removeEmptyGroups,
    sortedFeaturesMethod,
    productFeatureValue,
    findFeatureWithSelectedName,
    ...shoppingCartFunctions,

  },

}
</script>

<style scoped>
.product-card-903-keyword {
  background: gray;
}

.product-price-100 :deep(.product-price) {
  color: white !important;
}

.card450-product-date {
  font-size: 11px;
}

.product-card-450-text {
  font-size: 14px;
}

.product-card-450-publish-status-danger {
  background: #dc2530a1;
}

.product-card-450-publish-status-success {
  background: rgba(40, 167, 69, 0.85);
}
</style>